import { Component, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ValidatorFn } from '@angular/forms';
import { TravelerDetailComponent } from '@bhtp-client-web/component';
import { PrimaryTravelerFieldConfig } from './../../shared/models';

@Component({
    selector: 'primary-traveler-detail',
    template: require('./primary-traveler-detail.component.html')
})
export class PrimaryTravelerDetailComponent extends TravelerDetailComponent implements OnChanges, AfterViewInit {
    @Input() public configuration: PrimaryTravelerFieldConfig;
    @Input() public postalCodeError: string;

    public addressFormGroup: FormGroup;

    constructor(formBuilder: FormBuilder) {
        super(formBuilder);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.form && this.traveler && this.configuration && !this.formInitialized) {
            this.buildForm();
        }
    }

    ngAfterViewInit(): void {
        // Postalcode was entered on step 0 no need to allow edits here.
        if (this.addressFormGroup && this.addressFormGroup.controls && this.addressFormGroup.controls.postalCode) {
            this.addressFormGroup.controls.postalCode.disable();
        }
    }

    protected buildForm(): void {
        this.buildAgeControl();
        this.buildBirthDateControl();
        this.buildGenderControl();
        this.buildTripCostControl();
        this.buildAddressFormGroup();
        this.setUpValidationMessages();
        this.formInitialized = true;
    }

    protected buildAddressFormGroup(): void {
        this.addressFormGroup = this.formBuilder.group({});
        this.form.addControl('address', this.addressFormGroup);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/traveler/primary-traveler-detail.component.ts